module.exports = __webpack_public_path__ + "img/la_verite.421efa78.png";